/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lush_Mild_Calf_RoamInputs */

const en_lush_mild_calf_roam = /** @type {(inputs: Lush_Mild_Calf_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload`)
};

const de_lush_mild_calf_roam = /** @type {(inputs: Lush_Mild_Calf_RoamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinzufügen`)
};

/**
* | output |
* | --- |
* | "Upload" |
*
* @param {Lush_Mild_Calf_RoamInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lush_mild_calf_roam = /** @type {((inputs?: Lush_Mild_Calf_RoamInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lush_Mild_Calf_RoamInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lush_mild_calf_roam(inputs)
	return de_lush_mild_calf_roam(inputs)
});